/* PRISKEL REDESIGN v2 — hero slides, shop the look, reviews, copy code */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inr = function (paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pk-copy]');
    if (!b) return;
    var code = b.getAttribute('data-pk-copy');
    var done = function () {
      var l = b.querySelector('[data-pk-copy-l]');
      if (!l) return;
      var t = l.textContent; l.textContent = 'Copied'; setTimeout(function () { l.textContent = t; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  function hero(h) {
    if (h.dataset.ready) return; h.dataset.ready = 1;
    var slides = [].slice.call(h.querySelectorAll('[data-pk-slide]'));
    var dots = [].slice.call(h.querySelectorAll('[data-pk-dot]'));
    if (slides.length < 2) return;
    var dur = (parseInt(h.getAttribute('data-speed'), 10) || 6) * 1000;
    h.style.setProperty('--pk-hero-dur', dur + 'ms');
    var i = 0, t = null, paused = false;
    function go(n) {
      slides[i].classList.remove('is-on'); slides[i].setAttribute('aria-hidden', 'true'); slides[i].setAttribute('inert', '');
      if (dots[i]) { dots[i].classList.remove('is-on'); dots[i].setAttribute('aria-selected', 'false'); }
      i = (n + slides.length) % slides.length;
      var s = slides[i];
      s.classList.add('is-on'); s.removeAttribute('aria-hidden'); s.removeAttribute('inert');
      [].forEach.call(s.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
      if (dots[i]) {
        var sp = dots[i].querySelector('span'); if (sp) { sp.style.animation = 'none'; void sp.offsetWidth; sp.style.animation = ''; }
        dots[i].classList.add('is-on'); dots[i].setAttribute('aria-selected', 'true');
      }
      schedule();
    }
    function schedule() { clearTimeout(t); if (!paused) t = setTimeout(function () { go(i + 1); }, dur); }
    function pause(p) { paused = p; h.classList.toggle('is-paused', p); if (p) clearTimeout(t); else schedule(); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    /* keep rotating while the cursor rests on the photo; hold only over a button or link */
    h.addEventListener('mouseover', function (e) { if (e.target.closest('a,button')) pause(true); });
    h.addEventListener('mouseout', function (e) { var a = e.target.closest('a,button'); if (a && !(e.relatedTarget && a.contains(e.relatedTarget))) pause(false); });
    h.addEventListener('mouseleave', function () { pause(false); });
    h.addEventListener('focusin', function (e) { try { if (e.target.matches(':focus-visible')) pause(true); } catch (_) {} });
    h.addEventListener('focusout', function (e) { if (!h.contains(e.relatedTarget)) pause(false); });
    document.addEventListener('visibilitychange', function () { pause(document.hidden); });
    var x0 = null;
    h.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    h.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
    });
    schedule();
  }

  function stack(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var t2 = parseInt(sec.getAttribute('data-t2'), 10) || 0;
    var t3 = parseInt(sec.getAttribute('data-t3'), 10) || 0;
    var rail = sec.querySelector('[data-pk-rail]');
    var prog = sec.querySelector('[data-pk-prog]');
    var prev = sec.querySelector('[data-pk-prev]'), next = sec.querySelector('[data-pk-next]');
    function upd() {
      if (!rail) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var vis = rail.clientWidth / rail.scrollWidth;
      if (prog) { prog.style.width = Math.max(vis * 100, 12) + '%'; prog.style.left = (max > 0 ? (rail.scrollLeft / max) * (100 - Math.max(vis * 100, 12)) : 0) + '%'; }
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
      var f = sec.querySelector('.pk-st__foot .pk-st__nav'); if (f) f.style.visibility = max > 4 ? 'visible' : 'hidden';
    }
    function step(d) { var c = rail.querySelector('.pk-st__look'); var w = c ? c.getBoundingClientRect().width + 22 : rail.clientWidth * .8; rail.scrollBy({ left: d * w, behavior: reduce ? 'auto' : 'smooth' }); }
    if (rail) { rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd(); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function price(look) {
      var picks = [].slice.call(look.querySelectorAll('[data-pk-pick]'));
      var on = picks.filter(function (p) { return p.checked; });
      var n = on.length, sub = 0, mrp = 0;
      on.forEach(function (p) { sub += +p.dataset.price; mrp += Math.max(+p.dataset.mrp, +p.dataset.price); });
      var pct = n >= 3 ? t3 : (n === 2 ? t2 : 0);
      var off = Math.round(sub * pct / 100 / 100) * 100;
      var pay = sub - off, save = mrp - pay;
      var o = function (k) { return look.querySelector('[data-o="' + k + '"]'); };
      o('mrp').textContent = inr(mrp);
      o('sub').textContent = inr(sub);
      o('offl').textContent = pct ? 'Stack & Save, ' + pct + '% off' : 'Stack & Save';
      o('off').textContent = pct ? '−' + inr(off) : (n === 1 ? 'Add 1 more for ' + t2 + '% off' : '—');
      o('pay').textContent = inr(pay);
      o('you').innerHTML = save > 0 ? 'You save <b>' + inr(save) + '</b> (' + Math.round(save * 100 / mrp) + '% off MRP)' : '';
      var btn = look.querySelector('[data-pkv-add]');
      btn.disabled = n === 0;
      btn.textContent = n === 0 ? 'Pick at least one piece' : (n === 1 ? 'Add to bag · ' + inr(pay) : 'Add the look · ' + inr(pay) + (save > 0 ? ' · Save ' + inr(save) : ''));
    }
    [].forEach.call(sec.querySelectorAll('[data-pkv-look]'), function (look) {
      look.addEventListener('change', function (e) {
        var v = e.target.closest('[data-pk-var]');
        if (v) {
          var li = v.closest('.pk-st__item'), cb = li.querySelector('[data-pk-pick]'), op = v.options[v.selectedIndex];
          cb.dataset.id = op.value; cb.dataset.price = op.dataset.price; cb.dataset.mrp = op.dataset.mrp;
          var b = li.querySelector('[data-pk-iprice]'), s = li.querySelector('[data-pk-imrp]');
          if (b) b.textContent = inr(+op.dataset.price);
          if (s) s.textContent = +op.dataset.mrp > +op.dataset.price ? inr(+op.dataset.mrp) : '';
        }
        price(look);
      });
      price(look);
      var add = look.querySelector('[data-pkv-add]'), msg = look.querySelector('[data-pkv-msg]');
      add.addEventListener('click', function () {
        var items = [].slice.call(look.querySelectorAll('[data-pk-pick]')).filter(function (p) { return p.checked; }).map(function (p) { return { id: +p.dataset.id, quantity: 1 }; });
        if (!items.length) return;
        var label = add.textContent; add.disabled = true; add.textContent = 'Adding…'; msg.textContent = '';
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            [].forEach.call(document.querySelectorAll('hdt-cart-count'), function (c) { c.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            add.textContent = 'Added';
            var dlg = look.closest('dialog'); close(dlg);
            setTimeout(function () { add.disabled = false; price(look); var bag = document.querySelector('.pk-hd__bag'); if (bag) bag.click(); else location.href = '/cart'; }, 380);
          })
          .catch(function (err) { add.disabled = false; add.textContent = label; msg.textContent = err.message || 'Something went wrong. Please try again.'; });
      });
    });

    var lastBtn = null;
    function open(d, from) {
      if (!d) return; lastBtn = from || null;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      document.documentElement.classList.add('pk-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-in'); }); });
    }
    function close(d) {
      if (!d || !d.open) return;
      d.classList.remove('is-in');
      setTimeout(function () { if (d.open) { if (d.close) d.close(); else d.removeAttribute('open'); } document.documentElement.classList.remove('pk-lock'); if (lastBtn) lastBtn.focus({ preventScroll: true }); }, reduce ? 0 : 300);
    }
    sec.addEventListener('click', function (e) {
      var o = e.target.closest('[data-pk-open]');
      if (o) { open(document.getElementById(o.getAttribute('data-pk-open')), o); return; }
      var c = e.target.closest('[data-pk-close]');
      if (c) { close(c.closest('dialog')); return; }
      if (e.target.matches('dialog[data-pk-sheet]')) close(e.target);
    });
    [].forEach.call(sec.querySelectorAll('dialog[data-pk-sheet]'), function (d) {
      d.addEventListener('cancel', function (e) { e.preventDefault(); close(d); });
    });
  }

  function reviews(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var tr = sec.querySelector('[data-pk-rv-track]');
    var dots = [].slice.call(sec.querySelectorAll('[data-pk-rv-dot]'));
    if (!tr || !dots.length) return;
    var cards = [].slice.call(tr.children);
    function active() {
      var x = tr.scrollLeft, best = 0, d = 1e9;
      cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - tr.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      if (tr.scrollLeft >= tr.scrollWidth - tr.clientWidth - 4) best = cards.length - 1;
      dots.forEach(function (b, i) { b.classList.toggle('is-on', i === best); });
      return best;
    }
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(active); }, { passive: true });
    dots.forEach(function (b, i) { b.addEventListener('click', function () { tr.scrollTo({ left: cards[i].offsetLeft - tr.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }); });
    var timer = null, hold = false;
    function auto() { clearInterval(timer); if (reduce) return; timer = setInterval(function () { if (hold || document.hidden) return; var a = active(); var n = (a + 1) % cards.length; tr.scrollTo({ left: cards[n].offsetLeft - tr.offsetLeft, behavior: 'smooth' }); }, 6500); }
    sec.addEventListener('mouseenter', function () { hold = true; });
    sec.addEventListener('mouseleave', function () { hold = false; });
    tr.addEventListener('touchstart', function () { hold = true; }, { passive: true });
    auto();
  }

  function run() {
    [].forEach.call(document.querySelectorAll('[data-pk-hero]'), hero);
    [].forEach.call(document.querySelectorAll('[data-pkv-stack]'), stack);
    [].forEach.call(document.querySelectorAll('[data-pk-reviews]'), reviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
